import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { CrossCircle } from '../../../images/CrossCircle';

import s from './Inputs.scss';

interface IInputProps {
    id: string;
    label: string;
    register: (
        name: string,
        RegisterOptions?
    ) => { onChange; onBlur; name; ref };
    error?: string;
}

export function TextInput({
	id, label, error, register,
}: IInputProps) {
	useStyles(s);
	return (
		<div className="sl-teams-input">
			<label className="sl-teams-input__label" htmlFor={id}>
				{label}
			</label>
			<div className="sl-teams-input__input-wrapper">
				<input
					className="sl-teams-input__input"
					type="text"
					id={id}
					{...register(id)}
				/>
				{error && (
					<div className="sl-teams-input__error-icon">
						<CrossCircle />
					</div>
				)}
			</div>
			{error && <div className="sl-teams-input__error">{error}</div>}
		</div>
	);
}

interface ISelectInputProps extends IInputProps {
    options: {
        value: string;
        label: string;
    }[];
}

export function SelectInput({
	id,
	label,
	options,
	error,
	register,
}: ISelectInputProps) {
	return (
		<div className="sl-teams-input">
			<label className="sl-teams-input__label" htmlFor={id}>
				{label}
			</label>
			<div className="sl-teams-input__input-wrapper">
				<select
					className="sl-teams-input__input"
					id={id}
					{...register(id)}
				>
					{options.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</select>
				{error && (
					<div className="sl-teams-input__error-icon">
						<CrossCircle />
					</div>
				)}
			</div>
			{error && <div className="sl-teams-input__error">{error}</div>}
		</div>
	);
}
